<template>
    <v-dialog v-model="dialog" max-width="700px" persistent @keydown.esc="chiudiDialog()">
        <v-card>
            <v-card-title class="headline">
                Esporta dati EXCEL
                <v-spacer />
                <v-btn icon @click="chiudiDialog()">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text>

                <v-select label="Anno" v-model="annoSel" :items="anni" hide-details />

                <v-radio-group v-model="tipoDati">
                    <v-radio label="Materie prime" :value="'materiale'" />
                    <v-radio label="Commesse" :value="'commesse'" />
                    <v-radio label="Sintesi annuale" :value="'sintesi'" />
                </v-radio-group>

            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn @click="chiudiDialog">Chiudi</v-btn>
                <v-btn color="primary" @click="esportaDati()">Esporta</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
var XLSX = require("xlsx-js-style");

import { esporta_dati } from '@/api/api.registroSintesiPEFC.js'

export default {
    props: {
        dialog: { type: Boolean, default: false },
        compCode: { type: String, default: '' },
    },

    data() {
        return {
            tipoDati: 'materiale',
            anni: [],
            annoSel: new Date().getFullYear(),
        }
    },

    methods: {
        chiudiDialog() {
            this.$emit("close");
        },

        async esportaDati() {
            let data = {
                CompanyCode: this.compCode,
                Riferimento: this.tipoDati,
                Anno: this.annoSel,
            }
            let res = await esporta_dati(data);

            let sheetData = res.data;
            let nomeFile = this.tipoDati === "materiale" ? "ExportMateriePrime" : (this.tipoDati === "commesse" ? "ExportCommesse" : (this.tipoDati === "sintesi" ? "ExportSintesi" : ""));
            nomeFile += "_" + this.annoSel + "_" + this.$route.query.cliente || "";
            let workbook = XLSX.utils.book_new();
            let ws = XLSX.utils.aoa_to_sheet(sheetData);

            // Imposta larghezza colonne
            ws["!cols"] = this.getDimensioneColonne();

            // Calcola fusioni verticali per le prime 10 colonne
            if (this.tipoDati == "commesse")
                ws["!merges"] = this.generaFusioneVerticale(sheetData, 10);

            // Centra il testo nelle prime 10 colonne
            this.centraTesto(ws, sheetData, 10);

            // Applica lo stile alla prima riga
            this.stileIntestazione(ws, sheetData);

            XLSX.utils.book_append_sheet(workbook, ws, this.tipoDati);
            XLSX.writeFile(workbook, nomeFile + ".xlsx", { bookType: "xlsx", bookSST: false, type: "array" });
            this.$wait.close();
        },


        generaFusioneVerticale(sheetData, colonneDaUnire = 10) {
            const merges = [];

            // Determina i blocchi in base alla prima colonna (col 0)
            const blocchi = [];
            let startBlocco = 1;
            while (startBlocco < sheetData.length) {
                let endBlocco = startBlocco;
                while (endBlocco + 1 < sheetData.length && sheetData[endBlocco + 1][0] === sheetData[startBlocco][0]) {
                    endBlocco++;
                }
                blocchi.push({ start: startBlocco, end: endBlocco });
                startBlocco = endBlocco + 1;
            }

            // Per ogni colonna, unisci solo all'interno dello stesso blocco
            for (let col = 0; col < colonneDaUnire; col++) {
                for (const blocco of blocchi) {
                    let startRow = blocco.start;
                    while (startRow <= blocco.end) {
                        let currentValue = sheetData[startRow][col];
                        let endRow = startRow;

                        while (endRow + 1 <= blocco.end && sheetData[endRow + 1][col] === currentValue) {
                            endRow++;
                        }

                        if (endRow > startRow) {
                            merges.push({
                                s: { r: startRow, c: col },
                                e: { r: endRow, c: col }
                            });
                        }

                        startRow = endRow + 1;
                    }
                }
            }

            return merges;
        },

        centraTesto(ws, sheetData, colonneDaCentrare = 10) {
            for (let r = 0; r < sheetData.length; r++) {
                for (let c = 0; c < colonneDaCentrare; c++) {
                    const cellAddress = XLSX.utils.encode_cell({ r, c });
                    const cell = ws[cellAddress];
                    if (cell) {
                        cell.s = {
                            alignment: { horizontal: "center", vertical: "center" },
                        };
                    }
                }
            }
        },

        stileIntestazione(ws, sheetData) {
            for (let c = 0; c < sheetData[0].length; c++) {
                const cellAddress = XLSX.utils.encode_cell({ r: 0, c });
                const cell = ws[cellAddress];
                if (cell) {
                    cell.s = {
                        font: {
                            name: "Calibri",
                            sz: 13,
                            bold: true
                        },
                        alignment: {
                            horizontal: "center",
                            vertical: "center"
                        },
                        border: {
                            top: { style: "thin", color: { rgb: "000000" } },
                            bottom: { style: "thin", color: { rgb: "000000" } },
                            left: { style: "thin", color: { rgb: "000000" } },
                            right: { style: "thin", color: { rgb: "000000" } }
                        }
                    };
                }
            }
        },

        getDimensioneColonne() {
            return [
                { wch: 25 },
                { wch: 22 },
                { wch: 22 },
                { wch: 22 },
                { wch: 20 },
                { wch: 15 },
                { wch: 10 },

                { wch: 15 },
                { wch: 10 },
                { wch: 10 },
                { wch: 30 },
                { wch: 20 },
                { wch: 14 },
                { wch: 14 },
                { wch: 18 },
                { wch: 25 },
                { wch: 18 },
                { wch: 18 },
                { wch: 12 },
                { wch: 12 },
            ];
        },

        init() {
            let currentYear = new Date().getFullYear();
            for (let i = 2024; i <= currentYear; i++) {
                this.anni.push(i);
            }
        },
    },


    computed: {
        role() {
            return this.$store.getters['user/getRole'];
        }
    },

    watch: {
        dialog(newVal) {
            if (newVal) {
                this.init();
            }
        }
    }
}
</script>